export default __webpack_public_path__ + "static/media/(17).0feb841b.jpeg";